(() => {
  const tryPlay = (video) => {
    if (!video) return;
    const attempt = video.play();
    if (attempt && typeof attempt.catch === 'function') {
      attempt.catch(() => {});
    }
  };

  const isVisible = (el) => {
    if (!el || !el.isConnected) return false;
    const style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    const rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  };

  const revealVideo = (root, video) => {
    if (!root || root.dataset.inlineReady === 'true') return;
    root.dataset.inlineReady = 'true';
    root.classList.add('is-playing');
    const poster = root.querySelector('[data-inline-poster]');
    if (poster) poster.hidden = true;
    tryPlay(video);
  };

  const activate = (root) => {
    if (!root || root.dataset.inlineActive === 'true') return;
    root.dataset.inlineActive = 'true';

    const iframe = root.querySelector('iframe[data-inline-embed]');
    if (iframe && iframe.dataset.src && !iframe.getAttribute('src')) {
      iframe.setAttribute('src', iframe.dataset.src);
      root.classList.add('is-playing');
      const poster = root.querySelector('[data-inline-poster]');
      if (poster) poster.hidden = true;
      return;
    }

    const video = root.querySelector('video[data-inline-autoplay]');
    if (!video) {
      root.classList.add('is-playing');
      const poster = root.querySelector('[data-inline-poster]');
      if (poster) poster.hidden = true;
      return;
    }

    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.controls = false;
    video.loop = true;
    video.autoplay = true;
    video.preload = 'auto';

    const onReady = () => revealVideo(root, video);

    if (video.readyState >= 2) {
      onReady();
    } else {
      video.addEventListener('loadeddata', onReady, { once: true });
      video.addEventListener('canplay', onReady, { once: true });
    }

    if (video.networkState === 0 || video.readyState === 0) {
      video.load();
    }
    tryPlay(video);
  };

  const initVideo = (root) => {
    if (!root || root.dataset.inlineBound === 'true') return;
    root.dataset.inlineBound = 'true';

    const startIfVisible = () => {
      if (!isVisible(root)) return false;
      activate(root);
      return true;
    };

    if (startIfVisible()) return;

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && isVisible(root)) {
              activate(root);
              observer.disconnect();
            }
          });
        },
        { rootMargin: '80px', threshold: 0.1 }
      );
      observer.observe(root);
    }

    window.addEventListener(
      'resize',
      () => {
        startIfVisible();
      },
      { passive: true }
    );
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-inline-video]').forEach(initVideo);
  };

  window.JaafitInlineVideo = { init: initAll, initOne: initVideo };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }
})();
